module.exports = __webpack_public_path__ + "img/c08_unitcaravan_Normal_ua.e545c8bf.webp";